import { useState } from 'react'
import AreeService from '../services/AreeService/AreeService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useAree = () => {
  const [showModalContenuto, setShowModalContenuto] = useState(false);
  
    const [loadingState, setLoadingState] = useState({
        isLoadingAreeOrSottoaree: false,
        isLoadingAreeOrSottoareeByIdCorso: false,
        isLoadingAreaOrSottoareaCreating: false,
        isLoadingAreaOrSottoareaDelete: false,
        isLoadingAreaOrSottoareaUpdate: false,
        isLoadingAggiornaOrdineTree: false
      });

      const [modalState, setModalState] = useState({
        showModalUpdateAreaOrSottoarea: false
      });
  
      const getAllAreeOrSottoaree = async () => {
        setLoadingState({ ...loadingState, isLoadingAreeOrSottoaree: true });
          try {
            let response = await AreeService.getAllAree();
            if (response.ok) {
              const aree = await response.json();
              return aree;
            } 
          } catch (error) {
            handleError(error)
          } finally {
            setLoadingState({ ...loadingState, isLoadingAreeOrSottoaree: false });
          }
        };

        const createAreaOrSottoarea = async (data, name) => {
          setLoadingState({ ...loadingState, isLoadingAreaOrSottoareaCreating: true });
          try {
              let response = await AreeService.createArea(data);
              if(response?.id) {
                setShowModalContenuto(false)
                alertService.success(`${name} creata con successo`, {autoClose: true});
                return response;
          }
          } catch (error) {
            handleError(error)
          } finally {
            setLoadingState({ ...loadingState, isLoadingAreaOrSottoareaCreating: false });
          }
        }

        const getAreeOrSottoareeByIdCorso = async (data) => {
          setLoadingState({ ...loadingState, isLoadingAreeOrSottoareeByIdCorso: true });
          try {
              let response = await AreeService.findAreeByIdCorso(data);
              return response;
            } catch (error) {
              handleError(error)
            } finally {
              setLoadingState({ ...loadingState, isLoadingAreeOrSottoareeByIdCorso: false });
            }
          }

          const updateAreaOrSottoarea = async (data) => {
            setLoadingState({ ...loadingState, isLoadingAreaOrSottoareaUpdate: true });
            try {
                let response = await AreeService.updateArea(data);
                  alertService.success(`Area aggiornata con successo`, {autoClose: true});
                  setModalState({...modalState, showModalUpdateAreaOrSottoarea: false });
                  return response;
              } catch (error) {
                handleError(error)
              } finally {
                setLoadingState({ ...loadingState, isLoadingAreaOrSottoareaUpdate: false });
            }
          }

          const deleteAreaOrSottoarea = async (data) => {
            try {
              setLoadingState({ ...loadingState, isLoadingAreaOrSottoareaDelete: true });
                let response = await AreeService.deleteArea(data);
                if(response.ok) {
                  alertService.success(`Area eliminata con successo`, {autoClose: true});
                  setModalState({...modalState, showModalUpdateAreaOrSottoarea: false });
                  return response;
                }
              } catch (error) {
                handleError(error)
              } finally {
                setLoadingState({ ...loadingState, isLoadingAreaOrSottoareaDelete: false });
            }
          }

          const aggiornaOrdineTree = async (data) => {
            setLoadingState({ ...loadingState, isLoadingAggiornaOrdineTree: true });
            try {
              const response = await AreeService.aggiornaOrdineTree(data);
              return response;
            } catch (error) {
              handleError(error)
            } finally {
              setLoadingState({ ...loadingState, isLoadingAggiornaOrdineTree: false });
            }
          }

  return {
    getAllAreeOrSottoaree,
    createAreaOrSottoarea,
    getAreeOrSottoareeByIdCorso,
    updateAreaOrSottoarea,
    loadingStateAreeOrSottoaree: loadingState,
    showModalContenutoAree: showModalContenuto,
    modalStateAree: modalState,
    deleteAreaOrSottoarea,
    setModalStateAree: setModalState,
    setShowModalContenutoAree: setShowModalContenuto,
    aggiornaOrdineTree
  }
}

export default useAree